import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

const WarningComponent = ({ warningMessage }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', alignSelf:'flex-start',  padding: '0 20px' }}>
      <FaExclamationCircle size={20} color='#fdd835' style={{ marginRight: 10 }} />
      <span style={{ color: '#fdd835', fontSize: 13, fontFamily: 'Inter_700Bold' }}>{warningMessage}</span>
    </div>
  );
};

export default WarningComponent;
